import React from 'react'
import '../css/dlp.less';

class DLPHeader extends React.Component{

	state={
		learnMoreClicked: false
	}

	handleLearnMoreClick(e){
		e.preventDefault();
		const { learnMoreClicked } = this.state;
		let copyBlock = document.querySelector('.disclaimer .more-about-products');

		/*if learnMoreClicked state is initially false, or if the 'inactive' class is on the copyBlock element,
		  open the copy block. Otherwise, don't click on the copy block button (since it would trigger closing the copy block)
		  but instead, just scroll to it.
		*/
		if((learnMoreClicked === false || /(^|[ ])+inactive/.test(copyBlock.className)) && copyBlock){
			copyBlock.click();
			this.setState({learnMoreClicked: true});
		}

		copyBlock && copyBlock.scrollIntoView({behavior: 'smooth'});
	}

	contentRendered = () => {
		const {seoParagraph} = this.props;
		if(seoParagraph) {
			let seoParagraphObj;
			try{
				seoParagraphObj = JSON.parse(seoParagraph);
			}catch(e){
				seoParagraphObj = {};
			}
			//Check if there's content
			const {blocks=[]} = seoParagraphObj || {};
			//If there's only one line && that line is empty
			if(blocks.length === 1 && blocks[0].text.trim() === "") {
				return false;
			}

			return true;
		}

		return false;



	}

	renderHeaderDetails(){
		const {keyword, hideSeoParagraph = false} = this.props;

		return (
				<div className="dlp-header">
					<h1 className="keyword">
							{keyword}
					</h1>
					{this.contentRendered() && !hideSeoParagraph && <a className="dlp-learn-more" href="#" onClick={e => this.handleLearnMoreClick(e)}>  Learn more +</a>}
				</div>
		)
	}

	render(){
		const { keyword, hideSeoParagraph = false } = this.props;
		return keyword && ( <div className="dlp-header-container">
					{this.renderHeaderDetails()}
			</div>
		);
	}
}

export default DLPHeader;
